module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/product-images/product-08-014aefdafe6c40643cdf0868cbe3aae8.jpg";